<app-header *ngIf="!isEmbedWLSMode && !isWhiteLabelCoverPageVisible && !isCoverPageShellRoute"></app-header>
<!-- Minimal header with logo for embed/preview mode -->
<div
  *ngIf="isEmbedWLSMode"
  class="wls-preview-header"
  [class.wls-preview-header--text-logo]="previewIsTextLogo"
>
  <div class="wls-preview-header__brand">
    <img
      *ngIf="previewLogoUrl"
      [src]="previewLogoUrl"
      alt="Logo"
      class="wls-preview-logo"
    />
  </div>

  <div class="wls-preview-header__actions">
    <a
      class="wls-preview-header__cta"
      appSpaLink
      [href]="loginPath"
    >
      {{ wlsPreviewHeaderLabels.GET_STARTED }}
    </a>
    <div class="wls-preview-header__language-switcher">
      <app-language-switcher [isEditMode]="true"></app-language-switcher>
    </div>
  </div>
</div>
<div
  [ngClass]="{
    'main-wrapper container with-sidebar': showSidebar && !isWhiteLabelCoverPageVisible,
    'white-label-cover-page-shell': isWhiteLabelCoverPageVisible,
    'wls-quick-preview': isEmbedWLSMode
  }"
>
  <app-sidebar
    *ngIf="showSidebar && !isWhiteLabelCoverPageVisible"
  ></app-sidebar>
  <div
    class="router-outlet-wrapper"
    [ngClass]="{'with-sidebar': showSidebar && !isWhiteLabelCoverPageVisible}"
  >
    <router-outlet (activate)="onActivate()"></router-outlet>
  </div>
</div>
<app-footer *ngIf="!isEmbedWLSMode && !isWhiteLabelCoverPageVisible"></app-footer>
<app-minimized-player></app-minimized-player>
<app-dev-toolbar *ngIf="showDevToolbar"></app-dev-toolbar>